/**
 * Created by eriksundqvist on 24/05/16.
 */
export const SET_USER_ID = 'invoice:set-user-id';
export const SET_TAX_ID = 'invoice:set-tax-id';
export const SET_SAVE_VACATION_PAY = 'invoice:set-save-vacation-pay';
export const SET_CUSTOMER_ENTITY = 'invoice:set-company-id';
export const SET_COUPON_ID = 'invoice:set-coupon-id';
export const SET_COUPON = 'invoice:set-coupon';
export const CLEAR_COUPON = 'invoice:clear-coupon';
export const SET_CURRENCY_ID = 'invoice:set-currency-id';
export const SET_CURRENCY_NAME = 'invoice:set-currency-name';
export const SET_CURRENCY_AMOUNT = 'invoice:set-currency-amount';
export const SET_AMOUNT = 'invoice:set-amount';
export const SET_SPECIFICATION = 'invoice:set-specification';
export const SET_INVOICEDATE = 'invoice:set-invoice-date';
export const SET_INVOICEUSER = 'invoice:set-invoice-user';
export const SET_SEND_TO_EMAIL = 'invoice:set-send-to-email';
export const SET_SEND_TO_EMAIL_SECONDARY = 'invoice:set-send-to-email-secondary';
export const SET_SEND_TO_EMAIL_BOOL = 'invoice:set-send-to-email-bool';
export const SET_COMPANY_PHONE = 'invoice:set-company-phone';
export const SET_EINVOICE_ADDRESS = 'invoice:set-einvoice-address';
export const SET_PO_NUMBER = 'invoice:set-po-number';
export const SET_TAX_KEY_ID = 'invoice:set-tax-key-id';
export const SET_EXPRESS_PAYMENT = 'invoice:set-express-payment';
export const SET_INVOICE_ID = 'invoice:set-invoice-id';
export const SET_CUSTOMER_ID = 'invoice:set-customer-id';
export const SET_SUBMITTED = 'invoice:set-submitted';
export const SET_VALID = 'invoice:set-valid';
export const SET_POSTING = 'invoice:set-posting';
export const SET_POST_ERROR = 'invoice:set-post-error';
export const SET_SUPPLIER_LEDGER = 'invoice:set-supplier-ledger';
export const CLEAR = 'invoice:clear';
export const SET_AMOUNT_INC_VAT = 'invoice:set-amount-inc-vat';
export const SET_LOCK_AMOUNT_DISTRIBUTION = 'invoice:set-lock-amount-distribution';
export const SET_INITIALIZING = 'invoice:set-initializing';
export const SET_AMOUNT_AFTER_HSD = 'invoice:set-amount-after-hsd';
export const SET_ROT = 'invoice:set-rot';
export const SET_RUT = 'invoice:set-rut';
export const SET_MANUAL_INVOICE_CALC = 'invoice:set-manual-invoice-calc';
export const SET_DISPLAY_DATES = 'invoice:set-display-dates';
export const SET_DISPLAY_HOURS = 'invoice:set-display-hours';
export const SET_PREREPORT = 'invoice:set-prereport';
export const SET_PREREPORTED_AT = 'invoice:set-prereported-at';
export const SET_TERMSACCEPTED = 'invoice:set-termsaccepted';
export const SET_LOGGED_IN_INVOICE_USER_TAXKEYS = 'invoice:set-logged-in-invoice-user-taxkeys';
export const SET_LOGGED_IN_INVOICE_USER_TAXKEY_ID = 'invoice:set-logged-in-invoice-user-taxkey-id';
export const SET_MESSAGE_TYPE = 'invoice:set-message-type';
export const SET_SURVEY_ANSWERS = 'invoice:set-survey-answers';



/** WEBPACK FOOTER **
 ** ./src/redux/modules/invoice/action-types.js
 **/